import { render, staticRenderFns } from "./locationBatches.vue?vue&type=template&id=4e2d91dd&scoped=true&"
import script from "./locationBatches.vue?vue&type=script&lang=js&"
export * from "./locationBatches.vue?vue&type=script&lang=js&"
import style0 from "./locationBatches.vue?vue&type=style&index=0&id=4e2d91dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d91dd",
  null
  
)

export default component.exports